export function getAppConfigURL(): string {
	return '/authenticated/config';
}
